import { FETCH_BULK_REFILL_LIST } from "../../constants/action.constants";

const initialState = {
  list: [],
  others: {
    total: 0,
    offset: 0,
    limit: 10,
  },
};

const bulkRefillList = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_BULK_REFILL_LIST:
      return { list: action.payload, others: action.others };
    default:
      return state;
  }
};

export default bulkRefillList;
